module.exports = __webpack_public_path__ + "media/h264homemp43.6aa3da0d.mp4";